import { FieldsError, PolicyToolError } from '~/Api/Error';

// Substrings: some answers are full sentences, and phrasing varies per endpoint.
const EXPECTED_ERROR_MESSAGES = [
  'invalid credentials',
  'user not found',
  'user is not subscribed',
  'user is not signed up',
  'user is already signed up',
  'already registered',
  'too many requests',
  'try again later',
  'session has expired',
];

const EXPECTED_HTTP_STATUSES = [429];

const getStatus = (error: unknown): number | undefined =>
  typeof error === 'object' && error !== null
    ? (error as { status?: number }).status
    : undefined;

// True for a known business answer; anything unrecognized keeps being reported.
export const isExpectedError = (error: unknown, message: string): boolean => {
  // Extends FieldsError, but its volume is still worth watching.
  if (error instanceof PolicyToolError) {
    return false;
  }

  if (error instanceof FieldsError) {
    return true;
  }

  const status = getStatus(error);

  if (status !== undefined && EXPECTED_HTTP_STATUSES.includes(status)) {
    return true;
  }

  const normalizedMessage = String(message ?? '').toLowerCase();

  return EXPECTED_ERROR_MESSAGES.some((expected) =>
    normalizedMessage.includes(expected),
  );
};
